//import { makeStyles } from '@material-ui/core';
import ilustracao from './IlustraçãoHome.svg';
import { Container,Button, makeStyles } from '@material-ui/core';
import { css } from 'styled-components';
import bndeslogo from '../../../sharedImgs/BNDESLOGO.svg';
import {openInfoGuide} from '../../../Enhancers/useAnalytics';

const PaytoneFont = css`
@import url('https://fonts.googleapis.com/css2?family=Paytone+One&display=swap');
`;

const useStyles = makeStyles({
    root: {
        "@media (max-width: 576px)": {
            display: 'flex',
            position: 'center'
        },
        "@media (max-width: 720px)": {
            display: 'flex',
            position: 'center'
        },
        "@media (max-width: 960px)": {
            display: 'flex',
            position: 'center'
        },
        "@media (min-width: 961px)": {
            display: 'contents'
        },
    },
    div: {
        display: 'flex'
    },
    h2: {
        margin: 20,
        marginTop: 100,
        fontFamily: 'Paytone One',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '50px',
        lineHeight: '145.8%',
        letterSpacing: '0.02em',
        color: '#8002BB',
        display: 'flex',
        "@media (max-width: 576px)": {
            position: 'center'
        },
        "@media (max-width: 720px)": {
            position: 'center'
        },
        "@media (max-width: 1200px)": {
            position: 'center'
        },
        "@media (min-width: 1201px)": {
            position: 'absolute'
        },
    },
    h4: {
        margin: 20,
        marginTop: 300,
        fontFamily: PaytoneFont,
        fontStyle: 'normal',
        fontSize: '20px',
        lineHeight: '145.8%',
        letterSpacing: '0.02em',
        "@media (max-width: 576px)": {
            position: 'center',
            marginTop: 10,
        },
        "@media (max-width: 720px)": {
            position: 'center',
            marginTop: 10,
        },
        "@media (max-width: 1200px)": {
            position: 'center',
            marginTop: 10,
        },
        "@media (min-width: 1201px)": {
            position: 'absolute'
        },
        display: 'flex'
    },
    img: {
        "@media (max-width: 576px)": {
            visibility: 'hidden',
            display: 'none',
        },
        "@media (max-width: 720px)": {
            visibility: 'hidden',
            display: 'none',
        },
        "@media (max-width: 1200px)": {
            visibility: 'hidden',
            display: 'none',

        },
        "@media (min-width: 1201px)": {
            marginTop: 10,
            marginLeft: -10,
            maxHeight: 700,
            maxWidth: 900,
            display: 'flex',
            float: 'right',
        },
    },
    bndesImg: {
        height: 160,
        width: 160,
        paddingTop: 10,
        display: 'flex',
        "@media (max-width: 576px)": {
            position: 'center'
        },
        "@media (max-width: 720px)": {
            position: 'center'
        },
        "@media (max-width: 1200px)": {
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            height: 180,
            width: 200
        },
    },
    infoButton: {
        backgroundColor: '#E65E8D', 
        color: "#ffffff",
        height: "60px",
        width: '300px',
        margin: 20,
        marginTop: 400,
        fontFamily: PaytoneFont,
        fontStyle: 'normal',
        lineHeight: '145.8%',
        letterSpacing: '0.02em',
        "@media (max-width: 576px)": {
            position: 'center',
            marginTop: 10
        },
        "@media (max-width: 720px)": {
            position: 'center',
            marginTop: 10
        },
        "@media (max-width: 1200px)": {
            position: 'center',
            marginTop: 10
        },
        "@media (min-width: 1201px)": {
            position: 'absolute',
        },
        display: 'flex'
    }
});

export default function Presentation() {

    const classes = useStyles();

    const handleButtonClick = () =>{
        window.open('https://sites.google.com/view/meuguiadireitoagil', '_blank', 'noopener,noreferrer')
        openInfoGuide()
    }

    return (
        <>
            <div className={classes.root}>

                <Container style={{ marginLeft: '0', marginRight: '0' }} >
                    <img className={classes.bndesImg} src={bndeslogo} alt="simbolo de startup parceira do BNDES" />
                    <h2 className={classes.h2}>Justiça na palma da mão<br></br> para quem mais precisa</h2>
                    <h4 className={classes.h4}>Nós da Direito Ágil buscamos concretizar os direitos humanos <br></br> e aperfeiçoar o sistema de justiça, com foco nos ODS ONU</h4>
                    <Button onClick={() => handleButtonClick()} className={classes.infoButton} variant="contained" style={{  }}>
                        Acesse nosso guia informativo
                    </Button>
                </Container>
                <img className={classes.img} src={ilustracao} alt="simbolo do direito, conectado ao simbolo do design e da programacao" />
            </div>
            <Container className={classes.div}>
                <h3>Diferenciais</h3>
            </Container>
        </>
    );
}